<template>
  <!-- 優惠卷序號 -->
  <div>
    <navigation-bar Close/>
    <div class="main issue">
      <category-content v-for="(item, index) in list" :key="index">
        <el-row type="flex" justify="space-between">
          <el-col :span="18" class="date text-left">
            <span style="margin-right: 20px">{{item}}</span>
            <!-- <span>18:00</span> -->
          </el-col>
          <el-col :span="6" class="text-right" v-show="false">
            <span class="amount">{{'x'+ item.count}}</span>
          </el-col>
        </el-row>
        <div class="store text-left" v-show="false">
          {{'發放：'+ item.storeName}}
        </div>
      </category-content>
    </div>
    <loading
        :active.sync=isLoading
        :can-cancel="false"
        :is-full-page="true">
    </loading>
  </div>
</template>

<script>

import CategoryContent from '@/components/category/Content.vue';

export default {
    name: "IssueSerial",
    props: {
      isWeb: Boolean,
      dataTokenWeb: {default: ''},
    },
    components: {
        CategoryContent
    },
    data() {
        return {
            dataToken:this.isWeb? (this.dataTokenWeb.dataToken ?? "") : (this.$route.query.dataToken ?? "") ,
            dataObject: {},
            id: this.isWeb? this.dataTokenWeb.id : this.$route.params.id,
            couponId: this.isWeb? this.dataTokenWeb.couponId : this.$route.params.couponId,
            stageId: this.isWeb? (this.dataTokenWeb.stageId || 0) : (this.$route.params.stageId || 0),
            list: [],
            isLoading: false,
        }
    },
    created() {
        try {
            this.dataObject = this.$crypto.uriComponentToObject(this.dataToken)
            if (!this.$public.notNull(this.couponId) && this.dataObject.usedType === "IssueSerial" && this.dataObject.id > 0) {
                this.couponId = this.dataObject.id
            }
        } catch (e) {
            this.dataObject = {}
        }
    },
    mounted() {
        this.callGetMySelfCouponInfoByIdApi(this.id, this.couponId);
    },
    methods: {
        /** (我的票卷 內頁專用) 取得票卷詳情 */
        callGetMySelfCouponInfoByIdApi: function (id, couponId) {

            let self = this;
            self.isLoading = true;

            this.$http.fetchWithAuthEncrypt`GetCodeList${{
                couponId: couponId,
                stageId: self.stageId,
            }} ${json => {

                if (json.data !== null && json.data !== '') {
                    self.list = json.data.codeList;
                }
                self.isLoading = false;
            }}`;
        },
    }
}
</script>

<style lang="less" scoped>
/deep/ .content {
  padding: 12px 0px
}
.issue {
  padding: 20px;
}
.filter {
  margin-bottom: 15px;
  img {width: 75px;}
}
.date {
  color: #C1AE8A
}
.amount {
  color: #E37E84;
  font-size: 14px;
}
.store {
  color: #474645;
  font-size: 16px;
}
</style>